var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"generic-card",style:(_vm.sizeString)},[_c('div',{staticClass:"card shadow d-flex flex-column",class:_vm.innerCardStyle},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }